export default {
    state: {
        location: {},
    },
    getters: {},
    mutations: {
        setLocation(state, location) {
            state.location.lng = location.lng;
            state.location.lat = location.lat;
            state.location.radius = 3;
        },
    },
    actions: {},
};
